var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNameTableOpened(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M854.84 290.205L808.752 290.205L808.752 436.594L854.84 436.594C861.2 436.594 866.361 430.036 866.361 421.955L866.361 304.844C866.361 296.764 861.2 290.205 854.84 290.205L854.84 290.205Z",
    fill: "#f9b37b",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.227 436.594L807.14 436.594L807.14 582.983L853.227 582.983C859.587 582.983 864.749 576.425 864.749 568.344L864.749 451.233C864.749 443.152 859.587 436.594 853.227 436.594L853.227 436.594Z",
    fill: "#fff283",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.227 582.983L807.14 582.983L807.14 729.372L853.227 729.372C859.587 729.372 864.749 722.813 864.749 714.733L864.749 597.622C864.749 589.541 859.587 582.983 853.227 582.983L853.227 582.983Z",
    fill: "#8af291",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.587 118.634L802.553 118.634C808.619 118.634 813.537 123.064 813.537 128.529L813.537 894.211C813.537 899.675 808.619 904.105 802.553 904.105L195.587 904.105C189.52 904.105 184.602 899.675 184.602 894.211L184.602 128.529C184.602 123.064 189.52 118.634 195.587 118.634Z",
    fill: "#eaeae9",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "#c0c0c0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.77589
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.347 110.26L697.511 115.647L697.511 273.369L751.347 277.679C758.777 277.679 764.806 270.613 764.806 261.907L764.806 126.032C764.806 117.326 758.777 110.26 751.347 110.26L751.347 110.26Z",
    fill: "#f17a7a",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.538 916.571C706.538 922.88 699.7 932 695.319 932L247.857 912L247.857 112L696.96 76C701.341 76 708.18 85.12 708.18 91.4286",
    fill: "#60baff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.526 912C174.901 912 166.336 902.88 166.336 896.571L166.336 127.429C166.336 121.12 174.901 112 180.526 112L247.857 112L247.857 912L180.526 912Z",
    fill: "#046bc6",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.246 226.131L573.336 213.131C595 213.131 612.562 236.975 612.562 266.388L612.562 549.701C612.562 579.115 595 602.959 573.336 602.959L385.246 592.959C363.582 592.959 346.02 569.115 346.02 539.701L346.02 279.388C346.02 249.975 363.582 226.131 385.246 226.131Z",
    fill: "#848484",
    fillOpacity: 0.637387,
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.367 464.466C372.367 435.872 392.02 418.375 406.914 416.499L433.14 414.2C440.916 413.518 453.536 412.948 461.328 412.928L496.673 412.833C504.464 412.812 524.854 412.169 524.854 412.169L548.723 413.499C567.389 415.375 583.269 433.872 583.269 462.466L587.447 583.653C587.865 594.372 584.223 603.204 573.269 603.061C541.631 601.811 381.541 593.061 381.541 593.061C373.749 593.061 367.771 582.372 368.189 571.653L372.367 464.466Z",
    fill: "#046bc6",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.026 266.656C447.019 266.656 422.697 301.072 422.697 343.531C422.697 371.47 433.258 395.851 449.011 409.312C448.948 410.528 448.784 411.697 448.784 412.938C448.784 437.588 461.504 457.562 477.208 457.562L478.433 457.562C494.136 457.563 506.856 437.588 506.856 412.938C506.856 411.9 506.719 410.926 506.675 409.906C522.803 396.573 533.669 371.869 533.669 343.531C533.669 301.072 509.324 266.656 479.317 266.656L477.026 266.656Z",
    fill: "#ffdfab",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNameTableOpened);
export default __webpack_public_path__ + "static/media/NameTableOpened.f14a65561d0d19be7c91e8e3bf404e06.svg";
export { ForwardRef as ReactComponent };